import React, { useState, useEffect, useRef } from 'react';

declare global {
  interface Window {
    __SR_API_KEY__: string;
  }
}

/* ─── Icons (inline SVG components) ─── */
const IconCode = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" /></svg>
);
const IconCloud = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" /></svg>
);
const IconSmartphone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="14" height="20" x="5" y="2" rx="2" ry="2" /><path d="M12 18h.01" /></svg>
);
const IconBrain = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" /><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" /><path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" /><path d="M17.599 6.5a3 3 0 0 0 .399-1.375" /><path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" /><path d="M3.477 10.896a4 4 0 0 1 .585-.396" /><path d="M19.938 10.5a4 4 0 0 1 .585.396" /><path d="M6 18a4 4 0 0 1-1.967-.516" /><path d="M19.967 17.484A4 4 0 0 1 18 18" /></svg>
);
const IconLayers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" /><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" /><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" /></svg>
);
const IconRocket = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" /><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" /><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" /><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" /></svg>
);
const IconArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
);
const IconMail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
);
const IconCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
);
const IconMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="18" y2="18" /></svg>
);
const IconX = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
);

/* ─── Intersection Observer Hook ─── */
function useInView(options: IntersectionObserverInit = {}): [React.RefObject<HTMLElement | null>, boolean] {
  const ref = useRef<HTMLElement | null>(null);
  const [isInView, setIsInView] = useState(true);
  useEffect(() => {
    if (!ref.current) return;
    let isInitial = true;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.unobserve(entry.target);
        } else if (isInitial) {
          setIsInView(false);
        }
        isInitial = false;
      },
      { threshold: 0.1, ...options },
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return [ref, isInView];
}

/* ─── Navigation ─── */
function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const links = [
    { label: 'Services', href: '#services' },
    { label: 'Work', href: '#work' },
    { label: 'Process', href: '#process' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];
  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-night-950/80 backdrop-blur-xl border-b border-white/5' : ''}`}>
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#" className="flex items-center group">
          <img src="logo.png" alt="setReflex — software engineering studio" className="h-10 group-hover:opacity-80 transition-opacity" />
        </a>
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="text-sm text-night-300 hover:text-white transition-colors duration-300">{l.label}</a>
          ))}
          <a href="#contact" className="text-sm font-medium px-5 py-2.5 rounded-full bg-brand-600 hover:bg-brand-500 transition-colors duration-300">Start a project</a>
        </div>
        <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-night-300 hover:text-white">
          {mobileOpen ? <IconX /> : <IconMenu />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden bg-night-950/95 backdrop-blur-xl border-t border-white/5 px-6 pb-6">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setMobileOpen(false)} className="block py-3 text-night-300 hover:text-white transition-colors border-b border-white/5">{l.label}</a>
          ))}
          <a href="#contact" onClick={() => setMobileOpen(false)} className="block mt-4 text-center text-sm font-medium px-5 py-2.5 rounded-full bg-brand-600 hover:bg-brand-500 transition-colors">Start a project</a>
        </div>
      )}
    </nav>
  );
}

/* ─── Hero ─── */
function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden grid-bg">
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-brand-600/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-800/8 rounded-full blur-[100px] pointer-events-none" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20">
        <div className="fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass text-xs text-brand-300 font-medium mb-8 tracking-wide uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-400 animate-pulse" />
            Software Engineering Studio
          </div>
        </div>
        <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extrabold tracking-tight leading-[0.95] mb-6 fade-in-up-delay-1">
          We build software<br />
          <span className="gradient-text">that moves business</span><br />
          forward.
        </h1>
        <p className="text-lg sm:text-xl text-night-400 max-w-2xl mx-auto leading-relaxed mb-10 fade-in-up-delay-2">
          From cloud platforms to intelligent automation, we design and engineer solutions that scale with ambition. Over a decade of shipping products that matter.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 fade-in-up-delay-3">
          <a href="#contact" className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-600 hover:bg-brand-500 text-white font-medium transition-all duration-300 hover:shadow-xl hover:shadow-brand-600/25">
            Let's talk <span className="group-hover:translate-x-1 transition-transform"><IconArrowRight /></span>
          </a>
          <a href="#work" className="inline-flex items-center gap-2 px-8 py-4 rounded-full glass text-night-300 hover:text-white font-medium transition-all duration-300 hover:border-white/15">
            See our work
          </a>
        </div>
        <div className="mt-20 flex flex-wrap items-center justify-center gap-3 opacity-40">
          {['React', 'Node.js', 'TypeScript', 'Python', 'AWS', 'PostgreSQL', 'Docker', 'AI / ML'].map((t) => (
            <span key={t} className="text-xs font-mono px-3 py-1.5 rounded-full border border-white/10 text-night-400">{t}</span>
          ))}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-night-950 to-transparent" />
    </section>
  );
}

/* ─── Services ─── */
function Services() {
  const [ref, inView] = useInView();
  const services = [
    { icon: <IconLayers />, title: 'Web Platforms', desc: 'Full-stack applications built with modern frameworks. Responsive, performant, and designed to scale from day one.' },
    { icon: <IconSmartphone />, title: 'Mobile Apps', desc: 'Native and cross-platform experiences for iOS and Android. Polished interfaces backed by robust architecture.' },
    { icon: <IconCloud />, title: 'Cloud & DevOps', desc: 'Infrastructure as code, CI/CD pipelines, and cloud-native deployments on AWS, GCP, or Azure.' },
    { icon: <IconBrain />, title: 'AI & Automation', desc: 'Intelligent workflows, machine learning integrations, and conversational AI that reduce manual effort.' },
    { icon: <IconCode />, title: 'API Engineering', desc: 'RESTful and GraphQL APIs designed for reliability. Clean contracts, comprehensive documentation, and real-time capabilities.' },
    { icon: <IconRocket />, title: 'Product Strategy', desc: 'From concept validation to launch. We partner with founders and product teams to turn ideas into market-ready software.' },
  ];
  return (
    <section id="services" aria-labelledby="services-heading" className="relative py-32 px-6" ref={ref as React.Ref<HTMLElement>}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-brand-400 font-mono text-sm tracking-wider uppercase mb-4">What we do</p>
          <h2 id="services-heading" className="text-4xl sm:text-5xl font-bold tracking-tight">Engineering across the<br />full spectrum</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div key={i} className={`glass rounded-2xl p-8 card-hover transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${i * 100}ms` }}>
              <div className="w-12 h-12 rounded-xl bg-brand-600/10 text-brand-400 flex items-center justify-center mb-5">{s.icon}</div>
              <h3 className="text-lg font-semibold mb-3">{s.title}</h3>
              <p className="text-night-400 text-sm leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── Work / Portfolio ─── */
function Work() {
  const [ref, inView] = useInView();
  const projects = [
    { title: 'CloudSync Platform', tag: 'SaaS', desc: 'Real-time data synchronization platform for enterprise teams. Built on event-driven architecture serving 50k+ daily active users.', stack: ['React', 'Node.js', 'PostgreSQL', 'AWS'] },
    { title: 'HealthTrack Pro', tag: 'HealthTech', desc: 'Patient monitoring and clinical workflow management system. HIPAA-compliant, cross-platform mobile app with offline-first capability.', stack: ['React Native', 'Python', 'FastAPI', 'Docker'] },
    { title: 'NovaPay Gateway', tag: 'FinTech', desc: 'Payment processing middleware handling multi-currency transactions across European markets. PCI DSS Level 1 certified.', stack: ['TypeScript', 'Go', 'Redis', 'Kubernetes'] },
    { title: 'GreenRoute Logistics', tag: 'Logistics', desc: 'AI-powered route optimization and fleet management. Reduced delivery times by 34% through predictive scheduling.', stack: ['Python', 'TensorFlow', 'React', 'GCP'] },
  ];
  const gradients = [
    'bg-gradient-to-br from-brand-600/20 to-brand-900/30',
    'bg-gradient-to-br from-emerald-600/20 to-emerald-900/30',
    'bg-gradient-to-br from-violet-600/20 to-violet-900/30',
    'bg-gradient-to-br from-amber-600/20 to-amber-900/30',
  ];
  return (
    <section id="work" aria-labelledby="work-heading" className="relative py-32 px-6" ref={ref as React.Ref<HTMLElement>}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-brand-400 font-mono text-sm tracking-wider uppercase mb-4">Selected work</p>
          <h2 id="work-heading" className="text-4xl sm:text-5xl font-bold tracking-tight">Products we've helped<br />bring to life</h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {projects.map((p, i) => (
            <div key={i} className={`group glass rounded-2xl overflow-hidden card-hover transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${i * 120}ms` }}>
              <div className={`h-48 relative overflow-hidden ${gradients[i]}`}>
                <div className="absolute inset-0 opacity-30">
                  <div className={`absolute top-6 right-6 w-32 h-32 rounded-full border border-white/10 ${i % 2 === 0 ? 'float-slow' : 'float-mid'}`} />
                  <div className={`absolute bottom-4 left-8 w-20 h-20 rounded-xl border border-white/10 rotate-12 ${i % 2 === 0 ? 'float-mid' : 'float-fast'}`} />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full border border-white/5" />
                </div>
                <div className="absolute top-6 left-8">
                  <span className="text-xs font-mono px-3 py-1 rounded-full bg-white/10 text-white/70">{p.tag}</span>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold mb-3 group-hover:text-brand-400 transition-colors">{p.title}</h3>
                <p className="text-night-400 text-sm leading-relaxed mb-5">{p.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {p.stack.map((s) => (
                    <span key={s} className="text-xs font-mono px-2.5 py-1 rounded-md bg-white/5 text-night-400">{s}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── Process ─── */
function Process() {
  const [ref, inView] = useInView();
  const steps = [
    { num: '01', title: 'Discover', desc: 'We start by understanding your business, users, and goals. Research and workshops shape the technical strategy.' },
    { num: '02', title: 'Design', desc: 'Architecture decisions, prototyping, and UX design happen in tight feedback loops so we build the right thing.' },
    { num: '03', title: 'Build', desc: 'Iterative sprints deliver working software every two weeks. Transparent progress, continuous integration, zero surprises.' },
    { num: '04', title: 'Launch & Evolve', desc: 'Deployment is just the beginning. We monitor performance, gather feedback, and keep improving post-launch.' },
  ];
  return (
    <section id="process" aria-labelledby="process-heading" className="relative py-32 px-6" ref={ref as React.Ref<HTMLElement>}>
      <div className="max-w-5xl mx-auto">
        <div className={`text-center mb-20 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-brand-400 font-mono text-sm tracking-wider uppercase mb-4">How we work</p>
          <h2 id="process-heading" className="text-4xl sm:text-5xl font-bold tracking-tight">A clear path from<br />idea to product</h2>
        </div>
        <div className="space-y-0">
          {steps.map((s, i) => (
            <div key={i} className={`flex gap-8 items-start transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${i * 150}ms` }}>
              <div className="flex flex-col items-center shrink-0">
                <div className="w-14 h-14 rounded-2xl bg-brand-600/10 border border-brand-500/20 text-brand-400 font-mono font-bold text-sm flex items-center justify-center">{s.num}</div>
                {i < steps.length - 1 && <div className="w-px h-16 bg-gradient-to-b from-brand-500/20 to-transparent mt-2" />}
              </div>
              <div className="pb-12">
                <h3 className="text-xl font-bold mb-2">{s.title}</h3>
                <p className="text-night-400 text-sm leading-relaxed max-w-lg">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── About / Stats ─── */
function About() {
  const [ref, inView] = useInView();
  const stats = [
    { value: '12+', label: 'Years in business' },
    { value: '80+', label: 'Projects delivered' },
    { value: '35+', label: 'Long-term clients' },
    { value: '6', label: 'Countries served' },
  ];
  return (
    <section id="about" aria-labelledby="about-heading" className="relative py-32 px-6" ref={ref as React.Ref<HTMLElement>}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className={`transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-brand-400 font-mono text-sm tracking-wider uppercase mb-4">About us</p>
            <h2 id="about-heading" className="text-4xl sm:text-5xl font-bold tracking-tight mb-6">Small team,<br />big impact.</h2>
            <div className="space-y-4 text-night-400 leading-relaxed">
              <p>setReflex is a software engineering studio founded in Cluj-Napoca, Romania, and now working with clients across Europe and beyond. We started as mobile app builders and grew into a full-service product engineering partner.</p>
              <p>Our team combines deep technical expertise with genuine care for the products we help create. We write clean code, communicate clearly, and treat every project as if it were our own.</p>
              <p>We believe great software comes from small, focused teams that understand both the technology and the business behind it.</p>
            </div>
          </div>
          <div className={`grid grid-cols-2 gap-5 transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            {stats.map((s, i) => (
              <div key={i} className="glass rounded-2xl p-7 text-center card-hover">
                <div className="text-4xl font-extrabold gradient-text mb-2">{s.value}</div>
                <div className="text-sm text-night-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className={`mt-24 transition-all duration-700 delay-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-center text-night-500 text-sm uppercase tracking-wider mb-8">Technologies we work with</p>
          <div className="flex flex-wrap justify-center gap-4">
            {['TypeScript', 'React', 'Next.js', 'Node.js', 'Python', 'Go', 'PostgreSQL', 'MongoDB', 'Redis', 'AWS', 'Docker', 'Kubernetes', 'Terraform', 'GraphQL', 'TensorFlow'].map((t) => (
              <span key={t} className="text-sm font-mono px-4 py-2 rounded-xl glass text-night-300 hover:text-brand-400 hover:border-brand-500/20 transition-colors cursor-default">{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ─── Contact ─── */
function Contact() {
  const [ref, inView] = useInView();
  const [formState, setFormState] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      const res = await fetch('https://api.dragoste.net/setreflex/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': window.__SR_API_KEY__ || '',
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          message: formState.message,
        }),
      });
      if (!res.ok) throw new Error('Something went wrong. Please try again.');
      setSent(true);
      setFormState({ name: '', email: '', message: '' });
      setTimeout(() => setSent(false), 5000);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to send. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" aria-labelledby="contact-heading" className="relative py-32 px-6" ref={ref as React.Ref<HTMLElement>}>
      <div className="max-w-4xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-brand-400 font-mono text-sm tracking-wider uppercase mb-4">Get in touch</p>
          <h2 id="contact-heading" className="text-4xl sm:text-5xl font-bold tracking-tight mb-4">Ready to build<br />something great?</h2>
          <p className="text-night-400 max-w-lg mx-auto">Tell us about your project and we'll get back to you within 24 hours with a clear next step.</p>
        </div>
        <div className={`glass rounded-3xl p-8 sm:p-12 glow transition-all duration-700 delay-150 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {sent ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 rounded-full bg-emerald-500/10 text-emerald-400 flex items-center justify-center mx-auto mb-4"><IconCheck /></div>
              <h3 className="text-xl font-bold mb-2">Message sent!</h3>
              <p className="text-night-400">We'll be in touch soon.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm text-night-400 mb-2">Name</label>
                  <input type="text" required value={formState.name} onChange={(e) => setFormState({ ...formState, name: e.target.value })} placeholder="Your name" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-night-500 focus:outline-none focus:border-brand-500/50 focus:ring-1 focus:ring-brand-500/25 transition-colors" />
                </div>
                <div>
                  <label className="block text-sm text-night-400 mb-2">Email</label>
                  <input type="email" required value={formState.email} onChange={(e) => setFormState({ ...formState, email: e.target.value })} placeholder="you@company.com" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-night-500 focus:outline-none focus:border-brand-500/50 focus:ring-1 focus:ring-brand-500/25 transition-colors" />
                </div>
              </div>
              <div>
                <label className="block text-sm text-night-400 mb-2">Tell us about your project</label>
                <textarea required rows={5} value={formState.message} onChange={(e) => setFormState({ ...formState, message: e.target.value })} placeholder="What are you looking to build? What's the timeline? Any technical requirements?" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-night-500 focus:outline-none focus:border-brand-500/50 focus:ring-1 focus:ring-brand-500/25 transition-colors resize-none" />
              </div>
              {error && (
                <div className="px-4 py-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 text-sm">{error}</div>
              )}
              <button type="submit" disabled={sending} className={`group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-medium transition-all duration-300 ${sending ? 'bg-brand-700 cursor-wait opacity-70' : 'bg-brand-600 hover:bg-brand-500 hover:shadow-xl hover:shadow-brand-600/25'}`}>
                {sending ? 'Sending...' : 'Send message'}{' '}
                {!sending && <span className="group-hover:translate-x-1 transition-transform"><IconArrowRight /></span>}
              </button>
            </form>
          )}
        </div>
        <div className={`mt-10 flex flex-col sm:flex-row items-center justify-center gap-8 text-sm text-night-500 transition-all duration-700 delay-300 ${inView ? 'opacity-100' : 'opacity-0'}`}>
          <a href="mailto:hello@setreflex.com" className="inline-flex items-center gap-2 hover:text-brand-400 transition-colors"><IconMail /> hello@setreflex.com</a>
          <span className="hidden sm:inline text-night-700">|</span>
          <span>Cluj-Napoca, Romania</span>
          <span className="hidden sm:inline text-night-700">|</span>
          <span>Available across Europe</span>
        </div>
      </div>
    </section>
  );
}

/* ─── Footer ─── */
function Footer() {
  return (
    <footer className="border-t border-white/5 py-12 px-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="logo.png" alt="setReflex logo" className="h-7 opacity-50" />
          <span className="text-sm text-night-500">&copy; {new Date().getFullYear()}</span>
        </div>
        <div className="flex items-center gap-6">
          <a href="#services" className="text-xs text-night-500 hover:text-night-300 transition-colors">Services</a>
          <a href="#work" className="text-xs text-night-500 hover:text-night-300 transition-colors">Work</a>
          <a href="#about" className="text-xs text-night-500 hover:text-night-300 transition-colors">About</a>
          <a href="#contact" className="text-xs text-night-500 hover:text-night-300 transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  );
}

/* ─── App ─── */
export function App() {
  return (
    <div className="relative z-10">
      <Nav />
      <main>
        <Hero />
        <div className="line-glow" />
        <Services />
        <div className="line-glow" />
        <Work />
        <div className="line-glow" />
        <Process />
        <div className="line-glow" />
        <About />
        <div className="line-glow" />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
